import React, { Component } from 'react'
import { t } from 'i18next'
import stickybits from 'stickybits'
import Filters from './filters'
import Legend from './legend'
import Pickers from './pickers'
import Slideshow from './slideshow'
import './index.css'

export default class Houses extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeHouse: null,
      filters: {}
    }
  }

  setSticky() {
    if (window.innerWidth > 800) {
      stickybits(this.refs.legend, {
        useStickyClasses: true,
        stickyBitStickyOffset: document.querySelector('nav').clientHeight
      })
    }
  }

  componentDidMount() {
    this.setSticky()
    window.addEventListener('resize', this.setSticky())
  }

  updateFilter(filter, value) {
    const filters = this.state.filters
    filters[filter] === value ? filters[filter] = null : filters[filter] = value
    this.setState({ filters })
  }

  updateActiveHouse(activeHouse) {
    this.setState({ activeHouse }, () =>
      document.querySelector('.Houses').scrollIntoView()
    )
  }

  backToProjects() {
    this.setState({ activeHouse: null })
  }

  render() {
    const { activeHouse, filters } = this.state

    return (
      <div className="Houses">
        <div className="wrap">
          <h2>{t('houses.title')}</h2>
          <p>{t('get_inspired')}</p>

          <div className="legend" ref="legend">
            {activeHouse ?
              <Legend activeHouse={activeHouse} backToProjects={() => this.backToProjects()} /> :
              <Filters
                updateFilter={(filter, value) => this.updateFilter(filter, value)}
                activeFilters={filters} />
            }
          </div>

          {activeHouse ?
            <Slideshow activeHouse={activeHouse} /> :
            <Pickers
              updateActiveHouse={activeHouse => this.updateActiveHouse(activeHouse)}
              activeFilters={filters} />
          }

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Houses/index.js